import { createContext, PropsWithChildren, useContext, useState } from "react";

type ViewingOtherSpecialistInformationContextType = {
  isViewingOtherSpecialistInformation: boolean;
  toggleViewingOtherSpecialistInformation: () => void;
  setViewingSpecialistId: (specialistId: number) => void;
  viewingSpecialistId?: number;
  reset: () => void;
};

const ViewingOtherSpecialistInformationContext = createContext<ViewingOtherSpecialistInformationContextType>({} as any);

export const useViewingOtherSpecialistInformation = () => useContext(ViewingOtherSpecialistInformationContext);

export const ViewingOtherSpecialistInformationContextProvider = ({ children }: PropsWithChildren) => {
  const [isViewingOtherSpecialistInformation, setIsViewingOtherSpecialistInformation] = useState(false);
  const reset = () => {
    setIsViewingOtherSpecialistInformation(false);
    setViewingSpecialistId(undefined);
  };
  const [viewingSpecialistId, setViewingSpecialistId] = useState<number | undefined>(undefined);

  return (
    <ViewingOtherSpecialistInformationContext
      value={{
        isViewingOtherSpecialistInformation,
        toggleViewingOtherSpecialistInformation: () => setIsViewingOtherSpecialistInformation((prev) => !prev),
        setViewingSpecialistId,
        viewingSpecialistId,
        reset,
      }}
    >
      {children}
    </ViewingOtherSpecialistInformationContext>
  );
};
